import { render, staticRenderFns } from "./BoLayout.vue?vue&type=template&id=77d599da&"
import script from "./BoLayout.vue?vue&type=script&lang=js&"
export * from "./BoLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BoLayout.vue"
export default component.exports